/**
 * "Arrange by group" from the graph window (its zoom-bar button and its menus): arranges the
 * selection through the diagram service and says what happened. An action, never a switch.
 */
import { toast } from "../../../shared/toast";
import type { Diagram } from "../../../state/diagram";

/** Arranges the selected boxes, package or the whole diagram by group; tells the user. */
export async function arrangeSelection(diagram: Diagram): Promise<void> {
  const label = diagram.arrangeLabel();
  const result = await diagram.arrangeByGroup();
  if (result === "arranged") toast(`${label.replace(/^Arrange/, "Arranged")}. Press Ctrl+Z to undo.`);
  if (result === "unchanged") toast("Already arranged by group: nothing to change.");
}
